var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40.1826C31.0457 40.1826 40 31.2283 40 20.1826C40 9.13692 31.0457 0.182617 20 0.182617C8.9543 0.182617 0 9.13692 0 20.1826C0 31.2283 8.9543 40.1826 20 40.1826ZM28.7924 16.2634C28.7924 16.069 28.7888 15.8722 28.7792 15.6778C29.6648 15.0406 30.4328 14.2438 31.04 13.3342C30.2264 13.6954 29.3552 13.9366 28.4384 14.047C29.3732 13.4866 30.092 12.5986 30.4304 11.5414C29.5544 12.0598 28.5848 12.4366 27.554 12.6406C26.7272 11.7598 25.55 11.2114 24.2468 11.2114C21.7448 11.2114 19.718 13.2382 19.718 15.739C19.718 16.0954 19.7576 16.4398 19.8344 16.7722C16.07 16.5826 12.7304 14.7802 10.4972 12.0382C10.106 12.7078 9.8828 13.4866 9.8828 14.3158C9.8828 15.889 10.6832 17.2738 11.8988 18.0874C11.1572 18.0634 10.4576 17.8594 9.8468 17.5198V17.5762C9.8468 19.7722 11.408 21.6022 13.4804 22.0198C13.1012 22.123 12.7004 22.177 12.2864 22.177C11.9948 22.177 11.7104 22.1494 11.4344 22.0978C12.0104 23.8978 13.6844 25.2058 15.6656 25.243C14.1164 26.4562 12.164 27.181 10.04 27.181C9.6752 27.181 9.3152 27.1594 8.96 27.1174C10.9652 28.4038 13.3448 29.1538 15.9044 29.1538C24.236 29.1538 28.7924 22.2514 28.7924 16.2634Z",
    fill: "#FDDF33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_2105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbTwitterIcon);
export default __webpack_public_path__ + "static/media/BB-twitter-icon.399a7383f305854f0037c38c257e0bc5.svg";
export { ForwardRef as ReactComponent };